'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useCallback, Suspense } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderCartIcon from '@/app/_layout/HeaderCartIcon';
import HeaderAccountIcon from '@/app/_layout/HeaderAccountIcon';
import HeaderFavoritesIcon from '@/app/_layout/HeaderFavoritesIcon';
import NavSearchWidget from '@/app/_components/NavSearchWidget';
const HamburgerIcon = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    onClick
  } = t0;
  const t1 = isOpen ? "Close menu" : "Open menu";
  const t2 = `hamburger-bar block w-6 h-[1.5px] rounded-full bg-current transition-all duration-300 origin-center ${isOpen ? "rotate-45 translate-y-[7.5px] !bg-primary" : "group-hover:bg-primary"}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <span className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `hamburger-bar block w-6 h-[1.5px] rounded-full bg-current transition-all duration-300 ${isOpen ? "opacity-0 scale-x-0" : "group-hover:bg-primary"}`;
  let t5;
  if ($[2] !== t4) {
    t5 = <span className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = `hamburger-bar block w-6 h-[1.5px] rounded-full bg-current transition-all duration-300 origin-center ${isOpen ? "-rotate-45 -translate-y-[7.5px] !bg-primary" : "group-hover:bg-primary"}`;
  let t7;
  if ($[4] !== t6) {
    t7 = <span className={t6} />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== onClick || $[7] !== t1 || $[8] !== t3 || $[9] !== t5 || $[10] !== t7) {
    t8 = <button onClick={onClick} className="w-6 h-6 flex flex-col justify-center items-center gap-[6px] hover:cursor-pointer group" aria-label={t1}>{t3}{t5}{t7}</button>;
    $[6] = onClick;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default function IconNav(t0) {
  const $ = _c(11);
  const {
    mobileMenuOpen,
    openMobileMenu,
    closeMobileMenu
  } = t0;
  let t1;
  if ($[0] !== closeMobileMenu || $[1] !== mobileMenuOpen || $[2] !== openMobileMenu) {
    t1 = () => {
      if (mobileMenuOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    };
    $[0] = closeMobileMenu;
    $[1] = mobileMenuOpen;
    $[2] = openMobileMenu;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const toggleMenu = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavSearchWidget />;
    t3 = <HeaderFavoritesIcon className="hidden lg:block" />;
    t4 = <HeaderAccountIcon className="hidden lg:block" />;
    t5 = <HeaderCartIcon />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== mobileMenuOpen || $[9] !== toggleMenu) {
    t6 = <nav aria-label="Quick actions" className="flex items-center gap-4 lg:gap-4 lg:pb-2">{t2}{t3}{t4}{t5}<div className="block lg:hidden ml-2"><HamburgerIcon isOpen={mobileMenuOpen} onClick={toggleMenu} /></div></nav>;
    $[8] = mobileMenuOpen;
    $[9] = toggleMenu;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}